import nativeHandlerService from "../nativeHandler";

export const dateChecker = (headerTime) => {
  console.log("headerTime :>> ", headerTime);
  if (headerTime == undefined) return;

  // headerTimeはstringなので変換
  headerTime = new Date(headerTime);

  const now = new Date();

  const bufferMinutes = 5;

  const start = new Date(now);
  start.setMinutes(start.getMinutes() - bufferMinutes);

  const end = new Date(now);
  end.setMinutes(end.getMinutes() + bufferMinutes);

  if (!(headerTime >= start && headerTime <= end)) {
    // バッファ以内におさまらない場合、ネイティブコールでダイアログ出す。
    nativeHandlerService.returnNativeInvalidClientDateTime();
    throw "invalid client DateTime";
  }
};
